import React from "react"

import {CircularProgress} from "@mui/material"
interface LoaderProps {
    isLoading: boolean
    style?: any
}

export default function Loader(props: LoaderProps) {
    return (
        <div className={props.isLoading ? "fadeIn" : "fadeOut"} style={{...props.style}}>
            <CircularProgress className="loader" />
        </div>
    )
}
